var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',[_c('h1',{staticClass:"large-text"},[_vm._v("404")]),_c('p',[_vm._v("Page not found")]),_c('button',[_vm._v("Go to home")])])])
}]

export { render, staticRenderFns }